import CartForm from '@archetype-themes/modules/cart-form'
import { EVENTS } from '@archetype-themes/utils/events'

const updateKlarna = (price) => {
  const klarnaBannerElem = document.querySelector(`block-klarna klarna-placement`);
  if (klarnaBannerElem) {
    klarnaBannerElem.dataset.purchaseAmount = price;

    const klarnaBlockElem = document.querySelector(`block-klarna`);
    if (klarnaBlockElem) {
      const lowerLimit = parseInt(klarnaBlockElem.getAttribute('data-lower-limit-pence'), 10);
      const upperLimit = parseInt(klarnaBlockElem.getAttribute('data-upper-limit-pence'), 10);

      
      const priceTooLow = lowerLimit > 0 && price < lowerLimit;
      const priceTooHigh = upperLimit > 0 & price > upperLimit;

      const className = klarnaBlockElem.className.replace(' klarna-hide', '');

      if (priceTooLow || priceTooHigh) klarnaBlockElem.className = className.concat(' klarna-hide');
      else klarnaBlockElem.className = className;
    }
  }
}

const updateSplitit = (price) => {
  const splititBannerElem = document.querySelector(`block-splitit spt-one-liner`);
  if (splititBannerElem) {
    splititBannerElem.setAttribute('amount', (price / 100).toString());

    const splititBlockElem = document.querySelector(`block-splitit`);
    if (splititBlockElem) {
      const lowerLimit = parseInt(splititBlockElem.getAttribute('data-lower-limit-pence'), 10);
      const upperLimit = parseInt(splititBlockElem.getAttribute('data-upper-limit-pence'), 10);

      const priceTooLow = lowerLimit > 0 && price < lowerLimit;
      const priceTooHigh = upperLimit > 0 & price > upperLimit;

      const className = splititBlockElem.className.replace(' splitit-hide', '');

      if(priceTooLow || priceTooHigh) splititBlockElem.className = className.concat(' splitit-hide');
      else splititBlockElem.className = className;
    }
  }
}

if (document.body.classList.contains('template-cart')) {
  var cartPageForm = document.getElementById('CartPageForm')
  if (cartPageForm) {
    var cartForm = new CartForm(cartPageForm)

    document.addEventListener(EVENTS.ajaxProductAdded, () => cartForm.buildCart())
  }

  const hasPayInBanners = !!document.querySelector(`block-klarna klarna-placement`) ?? !!document.querySelector(`block-splitit div div`);
  if(hasPayInBanners)
    document.addEventListener(EVENTS.cartUpdated, (state) => {
      const price = state.detail?.cart?.total_price ?? 0;
      updateKlarna(price);
      updateSplitit(price)
    })
}
